import { WorkingDaysKey } from "../types/WorkingDaysKey";

export function getWorkingDaysString(workingDaysKey: WorkingDaysKey) {
	switch (workingDaysKey) {
		case "MoFr":
			return "1111100";
		case "MoSa":
			return "1111110";
		case "MoSu":
			return "1111111";
	}
}
